@if (!finishedLoading) {
    <cb-loading-spinner class="cb-margin"></cb-loading-spinner>
}
@if (finishedLoading) {
    <cb-dialog dialogHeading="Manage Attribute Items">
        <div class="end-center flex-row">
            <button class="cb-margin-bottom" mat-raised-button (click)="expandCollapseAll()">
                @if (!allPanelsExpanded()) {
                    <span class="start-center flex-row">
                        <span>Expand All&nbsp;</span>
                        <mat-icon>keyboard_arrow_down</mat-icon>
                    </span>
                }
                @if (allPanelsExpanded()) {
                    <span class="start-center flex-row">
                        <span>Collapse All&nbsp;</span>
                        <mat-icon>keyboard_arrow_up</mat-icon>
                    </span>
                }
            </button>
        </div>
        <div class="form-container">
            <form class="flex-col flex" #form="ngForm">
                <mat-accordion [multi]="true" class="accordion">
                    @for (group of groupedItems; track group) {
                        <mat-expansion-panel class="panel" [(expanded)]="group.expanded">
                            <mat-expansion-panel-header class="cb-padding-top cb-padding-bottom">
                                <mat-panel-title class="start-center flex-row">
                                    @if (group.anyEmptyItems()) {
                                        <mat-icon
                                            class="cb-error cb-help-cursor"
                                            matTooltip="Some Items Requiring Attributes"
                                            >panorama_fish_eye</mat-icon
                                        >
                                    }
                                    @if (!group.anyEmptyItems()) {
                                        <mat-icon
                                            class="mat-primary cb-help-cursor"
                                            matTooltip="All Item Attributes Set"
                                            >check_circle</mat-icon
                                        >
                                    }
                                    <span class="cb-margin-left mat-body-2">
                                        {{ group.label }}&nbsp;({{ group.items.length }})
                                    </span>
                                </mat-panel-title>
                                <mat-panel-description class="end-center flex-row">
                                    <button mat-icon-button (click)="togglePanelPinned(group.id)">
                                        <mat-icon
                                            svgIcon="pin"
                                            [ngClass]="{
                                                'cb-accent': userCacheItem.silentData[group.id]
                                            }"
                                        >
                                        </mat-icon>
                                    </button>
                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            @for (item of group.items; track item; let index = $index) {
                                <div class="cb-margin flex-col">
                                    <cb-table [loaded]="true">
                                        <thead cbTableHead>
                                            <tr>
                                                <td width="50%">
                                                    <div class="start-center flex-row">
                                                        <mat-icon
                                                            style="color: white"
                                                            title="Lot Specification Item"
                                                        >
                                                            style</mat-icon
                                                        >
                                                        <span class="mat-body-2"
                                                            >&nbsp; {{ item.slotName }} -
                                                            {{ item.offeringName }}</span
                                                        >
                                                    </div>
                                                </td>
                                                <td width="50%"></td>
                                            </tr>
                                        </thead>
                                        <tbody cbTableBody>
                                            @for (restriction of item.restrictions; track restriction) {
                                                <tr>
                                                    <td>
                                                        <cb-select
                                                            [label]="restriction.name"
                                                            [name]="
                                                                restriction.name +
                                                                '_option_' +
                                                                index +
                                                                '_' +
                                                                item.lotSpecScheduleItemVersionId
                                                            "
                                                            [(ngModel)]="restriction.selectedOptionId"
                                                            [options]="restriction.options"
                                                            (change)="
                                                                !item.$hasChanged &&
                                                                    attributeChanged(item)
                                                            "
                                                        >
                                                        </cb-select>
                                                    </td>
                                                    <td style="font-size: 12px">
                                                        <cb-text-area
                                                            label="Notes"
                                                            [name]="
                                                                restriction.name +
                                                                '_notes_' +
                                                                index +
                                                                '_' +
                                                                item.lotSpecScheduleItemVersionId
                                                            "
                                                            [(ngModel)]="restriction.notes"
                                                            [maxlength]="256"
                                                            [rows]="1"
                                                            (change)="
                                                                !item.$hasChanged &&
                                                                    attributeChanged(item)
                                                            "
                                                        >
                                                        </cb-text-area>
                                                    </td>
                                                </tr>
                                            }
                                            @if (item.manualColourEntryRequired) {
                                                <tr>
                                                    <td>
                                                        <cb-text-area
                                                            label="Manual Colour Entry"
                                                            [name]="
                                                                'manualColour_' +
                                                                item.id +
                                                                item.slotName +
                                                                item.lotSpecScheduleItemVersionId
                                                            "
                                                            [(ngModel)]="item.manualColourName"
                                                            [maxlength]="256"
                                                            [rows]="1"
                                                            (change)="
                                                                !item.$hasChanged &&
                                                                    attributeChanged(item)
                                                            "
                                                        >
                                                        </cb-text-area>
                                                    </td>
                                                    <td style="font-size: 12px">
                                                        <cb-text-area
                                                            label="Notes"
                                                            [(ngModel)]="item.manualColourNotes"
                                                            [name]="
                                                                'manualColourNotes_' +
                                                                item.id +
                                                                item.slotName +
                                                                item.lotSpecScheduleItemVersionId
                                                            "
                                                            [maxlength]="256"
                                                            [rows]="1"
                                                            (change)="
                                                                !item.$hasChanged &&
                                                                    attributeChanged(item)
                                                            "
                                                        >
                                                        </cb-text-area>
                                                    </td>
                                                </tr>
                                            }
                                        </tbody>
                                    </cb-table>
                                </div>
                            }
                        </mat-expansion-panel>
                    }
                </mat-accordion>
                @if (groupedItems?.length < 1) {
                    <div class="cb-margin center-start flex-col flex">
                        <div class="center-center flex-row flex">
                            <cb-info-message
                                message="There are no Items that need an attribute selection for this Lot"
                            >
                            </cb-info-message>
                        </div>
                    </div>
                }
            </form>
        </div>
        <div actions>
            <button
                mat-raised-button
                color="primary"
                (cbClick)="save()"
                [clickLimit]="1"
                [disabled]="form.invalid || form.pristine || !itemsHaveChanged"
            >
                Save
            </button>
            <button mat-raised-button (click)="cancel(form.dirty || itemsHaveChanged)">Cancel</button>
        </div>
    </cb-dialog>
}
